import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorStyles from '../../css/components/forms/error-messages/errorMessages.css';
import { useTranslation } from 'react-i18next';

export const ERROR_MESSAGE_STYLES = {
	STANDARD: 'standard',
	INGAME: 'ingame',
	LOGIN: 'login',
	PASSWORD_FORGOTTEN: 'passwordForgotten',
};

function ErrorMessage ({
	text,
	suggestions = null,
	errorDelay = 0,
	style = ERROR_MESSAGE_STYLES.STANDARD,
	onSuggestionClick = null,
	showCloseIcon = false,
	onCloseIconClickCallback = () => {},
	hasLink = false,
	linkText = null,
	linkAction = null,
	inputType = null,
	suggestionId = null,
}) {
	const [errorVisible, setErrorVisible] = useState(false);
	const { t } = useTranslation('translation');

	useEffect(() => {
		if (text && !errorDelay) {
			setErrorVisible(true);
		} else if (text && errorDelay !== 0 && typeof(errorDelay) === 'number') {
			const timer1 = setTimeout(() => {
				setErrorVisible(true);
			}, errorDelay);

			return () => {
				clearTimeout(timer1);
			};
		} else {
			setErrorVisible(false);
		}
	}, [errorDelay, text]);

	return(
		<div>
			{errorVisible && (
				<section
					data-testid="errorMessage"
					className={`${errorStyles.errorMessage} ${errorStyles[style]} ${suggestions ? errorStyles.largeErrorMessage : ''} ${inputType === 'text' ? errorStyles.textError : ''}`}
				>
					<header>
						{text}
						{hasLink &&
							<a  
								onClick={() => {
									linkAction();
									onCloseIconClickCallback();
								}}
							> 
								{linkText}
							</a>
						}
					</header>
					{showCloseIcon && (
						<button
							onClick={onCloseIconClickCallback}
							className={errorStyles.closeIcon}
						>+</button>
					)}
					{suggestions && suggestions.length > 0 && (
						<main>
							<p className={errorStyles.helpingText}>{t('twoStepForm.username.errorMessages.suggestions.errorMessageEmpty')}</p>
							<ul 
								data-testid="suggestionList" 
								className={errorStyles.suggestionsList}
								id={suggestionId}
							>
								{suggestions.slice(0, 4).map((sug, i) => (
									<li
										onClick={ () => {onSuggestionClick(sug);}}
										key={i}
									>
										{sug}
									</li>
								))}
							</ul>
						</main>
					)}
				</section>
			)}
		</div>
	);
}

export default ErrorMessage;

ErrorMessage.propTypes = {
	text: PropTypes.string.isRequired,
	suggestions: PropTypes.arrayOf(PropTypes.string),
	errorDelay: PropTypes.number,
	style: PropTypes.oneOf(Object.values(ERROR_MESSAGE_STYLES)),
	onSuggestionClick: PropTypes.func,
	showCloseIcon: PropTypes.bool,
	onCloseIconClickCallback: PropTypes.func,
	hasLink: PropTypes.bool,
	linkText: PropTypes.string,
	linkAction: PropTypes.func,
	inputType: PropTypes.string,
	suggestionId: PropTypes.string
};